import { apiClient } from "@/lib/apiClient";
import { apiPath } from "@/lib/apiPath";

export type VisitState = "pending" | "confirmed" | "cancelled" | "past";

export type VisitResolve = {
  status: string;
  company_title: string;
  date: string | null;          // salon-local ISO date
  time: string | null;          // salon-local HH:MM
  master_name: string | null;
  services: string[];
  state: VisitState;
  outcome?: string;             // POST only: confirmed | already_confirmed | cancelled | already_cancelled | stale
};

/** The visit an SMS link names (Boona Direct, inbox plan INB5 in the backend
 * repo). Pure read — SMS apps and link scanners prefetch links. */
export async function resolveVisit(token: string): Promise<VisitResolve> {
  const { data } = await apiClient.get(apiPath(`/visit/${encodeURIComponent(token)}`));
  return data;
}

/** The client's explicit press: confirm or cancel her own visit. */
export async function commitVisit(token: string, action: "confirm" | "cancel"): Promise<VisitResolve> {
  const { data } = await apiClient.post(apiPath(`/visit/${encodeURIComponent(token)}`), { action });
  return data;
}
